module.exports = __webpack_public_path__ + "static/media/result_OMR.2685bcdd.png";